import React from "react";
import { ReactComponent as BG } from "icons/bg2.svg";

export default function Background() {
  return (
    <>
      <div className="background__con --vertical">
        <BG className="background__inner --vertical" />
        <BG className="background__inner --vertical" />
        <BG className="background__inner --vertical" />
        <BG className="background__inner --vertical" />
        <div className="background__con --horizontal">
          <BG className="background__inner --horizontal" />
          <BG className="background__inner --horizontal" />
          <BG className="background__inner --horizontal" />
          <BG className="background__inner --horizontal" />
        </div>
        <div className="background__inner --horizontial"></div>
      </div>
    </>
  );
}
